import React from 'react';

const LineLoader = () => {
  return(
    <div className="line-loader">
      <div></div>
      <div></div>
    </div>
  );
}

export default LineLoader;